// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_admin_admin_module_ts":"e908117213353427","common":"3ada9de987e235f1","src_app_authentication_authentication_module_ts":"c1d55c6f883a1de6","src_app_admin_dashboard_dashboard_module_ts":"6ef52825fc9d083c","node_modules_xlsx_dist_xlsx_mini_min_js":"6b845188167a56d1"}[chunkId] + ".js";
};